import { Button, Stack, TextField } from '@mui/material';
import { getSelectorAttribute } from '@vy/app-selectors';
import React from 'react';
import { useForm } from 'react-hook-form';
import { userMessage } from '../../../../../../../utils/vy-toasts';

type CreateCustomerNoteFormValues = {
  content: string;
};

type CreateCustomerNoteFormProps = {
  onSubmit: (values: CreateCustomerNoteFormValues) => Promise<void>;
  isCustomerNoteLoading: boolean;
};

export const CreateCustomerNoteForm: React.FC<CreateCustomerNoteFormProps> = ({
  onSubmit,
  isCustomerNoteLoading,
}) => {
  const { register, handleSubmit, reset, formState } = useForm<CreateCustomerNoteFormValues>({
    defaultValues: { content: '' },
  });

  const contentRegister = register('content', {
    required: 'Note content is required',
    maxLength: { value: 1000, message: 'Note cannot exceed 1000 characters' },
    validate: (value) => value.trim().length > 0 || 'Note content is required',
  });

  const handleFormSubmit = handleSubmit(async (values) => {
    try {
      await onSubmit(values);
      reset();
    } catch (_error) {
      userMessage('error', 'Unable to create note.');
    }
  });

  return (
    <Stack spacing={2}>
      <TextField
        {...contentRegister}
        placeholder="Add a note about this customer..."
        fullWidth
        multiline
        minRows={2}
        maxRows={2}
        disabled={formState.isSubmitting || isCustomerNoteLoading}
        error={!!formState.errors.content}
        helperText={formState.errors.content?.message}
        {...getSelectorAttribute('customer-notes-input')}
      />
      <Stack direction="row" sx={{
        justifyContent: "flex-end"
      }}>
        <Button
          variant="contained"
          disabled={!formState.isDirty || formState.isSubmitting || isCustomerNoteLoading}
          onClick={handleFormSubmit}
          loading={isCustomerNoteLoading}
          loadingPosition="end"
          {...getSelectorAttribute('customer-notes-submit-button')}
        >
          Add Note
        </Button>
      </Stack>
    </Stack>
  );
};
